import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Global Universal Logistics delivered an urgent parcel for our company within hours. Outstanding service.',
    author: 'James T.',
    role: 'Operations Manager'
  }, {
    quote: 'Their driver supply service helped our business during peak demand periods.',
    author: 'Sarah M.',
    role: 'Logistics Director'
  }, {
    quote: 'Reliable logistics partner with excellent response times.',
    author: 'David R.',
    role: 'Business Owner'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-177">
      <div className="container mx-auto px-4" data-id="element-178">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-179">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-180">
            What Our Clients Say
          </h2>
          <p className="text-lg text-slate-600" data-id="element-181">
            Don't just take our word for it. Here's what businesses across the
            UK have to say about our services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-182">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 relative" data-id="element-183">
              <QuoteIcon className="h-10 w-10 text-blue-100 absolute top-6 left-6" data-id="element-184" />
              <div className="relative z-10" data-id="element-185">
                <p className="text-slate-700 text-lg italic mb-6 pt-8" data-id="element-186">
                  "{testimonial.quote}"
                </p>
                <div data-id="element-187">
                  <p className="font-bold text-slate-900" data-id="element-188">
                    {testimonial.author}
                  </p>
                  <p className="text-sm text-primary font-medium" data-id="element-189">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}